import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-079db535"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-center flex flex-col items-center" }
const _hoisted_2 = { class: "my-8 md:my-16" }
const _hoisted_3 = { class: "mt-8 w-4/5" }
const _hoisted_4 = {
  class: "grid grid-cols-1 lg:grid-cols-3 mt-8 py-8 px-10 text-left gap-y-4",
  style: {"background-color":"#E8F4FF","border-radius":"6px"}
}
const _hoisted_5 = {
  class: "h-full text-primary flex items-center",
  style: {"font-size":"22px"}
}
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "h-full w-8/12" }
const _hoisted_8 = { class: "h-full w-8/12" }
const _hoisted_9 = { style: {"list-style-type":"disc"} }
const _hoisted_10 = {
  key: 0,
  class: "grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 2xl:grid-cols-2 gap-6 my-16 justify-items-center w-full sm:w-4/5"
}
const _hoisted_11 = {
  key: 1,
  class: "grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 2xl:grid-cols-2 gap-6 my-16 justify-items-center w-full sm:w-4/5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_toggle_switch = _resolveComponent("toggle-switch")!
  const _component_addon_card = _resolveComponent("addon-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t("Fugirne mase")), 1),
    _createVNode(_component_toggle_switch, {
      labels: _ctx.title,
      switched: _ctx.switched,
      isChecked: _ctx.isChecked
    }, null, 8, ["labels", "switched", "isChecked"]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("strong", {
            innerHTML: _ctx.$t('Priporočamo Premium<br>fugirne mase!')
          }, null, 8, _hoisted_6)
        ]),
        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("Zelo priporočamo izbiro Premium fugirnih mas! Prvotni vložek se vam kmalu povrne, saj nudijo izjemno dolgo in kakovostnejšo zaščito.")), 1),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("ul", _hoisted_9, [
            _createElementVNode("li", null, _toDisplayString(_ctx.$t("Bolj obstojne")), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$t("Zmanjša možonst rasti zelene vegetacije")), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$t("Varna za podtalnico")), 1)
          ])
        ])
      ])
    ]),
    (_ctx.isChecked)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.klasicne, (item) => {
            return (_openBlock(), _createBlock(_component_addon_card, {
              key: item,
              itemData: item,
              grout: true
            }, null, 8, ["itemData"]))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_11, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.premium, (item) => {
            return (_openBlock(), _createBlock(_component_addon_card, {
              key: item,
              itemData: item,
              grout: true
            }, null, 8, ["itemData"]))
          }), 128))
        ]))
  ]))
}